import React from 'react';

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="py-3">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <p className="m-0 text-center">Copyright &copy; 2025 Techtop. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default Footer;